import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Amplify, { Auth } from 'aws-amplify';

import config from './config';
import { BrowserRouter } from 'react-router-dom';

declare var process: {
    env: {
        SERVER_ENV: string;
        REACT_APP_PLATFORM?: string;
        REACT_APP_AUTH_DOMAIN?: string;
        REACT_APP_AUTH_REDIRECT_SIGN_IN?: string;
        REACT_APP_AUTH_REDIRECT_SIGN_OUT?: string;
    };
};

const envConfig = config[process.env.SERVER_ENV] || config.development;
// Social login (Cognito hosted UI) is only used on Members. Neighbors and Community keep the
// plain Amplify setup: with oauth configured, Amplify treats any ?code= in the URL (e.g. the
// reset-password link) as a social-login return, and signOut goes through the hosted UI.
const authDomain = process.env.REACT_APP_PLATFORM === 'members'
    ? (process.env.REACT_APP_AUTH_DOMAIN || (envConfig as any).authDomain)
    : '';
const redirectSignIn = process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN || window.location.origin;
const redirectSignOut = process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT || window.location.origin;

Amplify.configure({
    Auth: {
        region: envConfig.region,

        userPoolId: envConfig.userPoolId,
        userPoolWebClientId: envConfig.appClientId,

        authenticationFlowType: 'USER_PASSWORD_AUTH',
        ...(authDomain ? {
            oauth: {
                domain: authDomain,
                scope: ['email', 'openid', 'profile'],
                redirectSignIn,
                redirectSignOut,
                responseType: 'code',
            },
        } : {}),
    },
    API: {
        endpoints: [
            {
                name: 'lambda',
                endpoint: envConfig.lambdaEndpoint,
                custom_header: async () => {
                    try {
                        return {
                            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
                        };
                    } catch (error) {
                        return null;
                    }
                },
            },{
                name: 'public', 
                endpoint: envConfig.lambdaEndpoint
            },{
                name: 'testLambda',
                endpoint: envConfig.testLambdaEndpoint,
                custom_header: async () => {
                    try {
                        return {
                            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
                        };
                    } catch (error) {
                        return null;
                    }
                },
            }
        ],
    },
});

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
